import { BubbleMenuPlugin as e } from "./bubble-menu-plugin.mjs";
import { useCurrentEditor as t } from "@tiptap/react";
import n, { useEffect as r, useRef as i } from "react";
import { twMerge as a } from "tailwind-merge";
import { jsx as o } from "react/jsx-runtime";
import { createPortal as s } from "react-dom";
//#region src/components/bubble-menu/BubbleMenu.tsx
var c = n.forwardRef(({ pluginKey: n = "bubbleMenu", editor: c, updateDelay: l = 0, resizeDelay: u, appendTo: d, shouldShow: f = null, getReferencedVirtualElement: p, options: m, children: h, className: g, ..._ }, v) => {
	let y = i(document.createElement("div"));
	typeof v == "function" ? v(y.current) : v && (v.current = y.current);
	let { editor: b } = t(), x = c || b, S = {
		updateDelay: l,
		resizeDelay: u,
		appendTo: d,
		pluginKey: n,
		shouldShow: f,
		getReferencedVirtualElement: p,
		options: {
			placement: "bottom",
			offset: 10,
			...m
		}
	}, C = i(S);
	return C.current = S, r(() => {
		if (x?.isDestroyed) return;
		if (!x) {
			console.warn("BubbleMenu component is not rendered inside of an editor component or does not have editor prop.");
			return;
		}
		let t = y.current;
		t.style.visibility = "hidden", t.style.position = "absolute";
		let n = e({
			...C.current,
			editor: x,
			element: t
		});
		x.registerPlugin(n);
		let r = C.current.pluginKey;
		return () => {
			x.unregisterPlugin(r), window.requestAnimationFrame(() => {
				t.parentNode && t.parentNode.removeChild(t);
			});
		};
	}, [x]), s(/* @__PURE__ */ o("div", {
		className: a("bg-bg-primary border-border-100 shadow-2 relative z-20 rounded-lg border", g),
		..._,
		children: h
	}), y.current);
});
//#endregion
export { c as BubbleMenu };
